module.exports = __webpack_public_path__ + "static/Tanvi-a0bfba3d6d20a43a5f4cdfdbdc772c94.png";